import PropTypes from 'prop-types';

import seatShape from './seatShape';

export default PropTypes.shape({
  exit: PropTypes.bool.isRequired,
  wing: PropTypes.bool.isRequired,
  seats: PropTypes.arrayOf(seatShape).isRequired,
});
